export default "__VITE_ASSET__ea096d82__"